import { useEffect, useState } from 'react';

export function useLoadingIndicator(duration: number) {
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
  const [loadingStartTime, setLoadingStartTime] = useState<number | null>(null);

  useEffect(() => {
    let timer: NodeJS.Timeout;

    if (isLoading) {
      setLoadingStartTime(Date.now());
      setShowLoadingIndicator(true);
    } else {
      if (loadingStartTime !== null) {
        const loadingDuration = Date.now() - loadingStartTime;

        if (loadingDuration < duration) {
          timer = setTimeout(() => {
            setShowLoadingIndicator(false);
          }, duration - loadingDuration);
        } else {
          setShowLoadingIndicator(false);
        }
      }
    }

    return () => clearTimeout(timer);
  }, [isLoading]);

  return {
    showLoadingIndicator,
    setIsLoading,
  };
}
